import { ConfigProvider } from "antd";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import zhTW from "antd/es/locale/zh_TW";
import LayoutPage from '@components/layoutPage';
import '@/App.less'; //用 @ 表示 ./src
import '@styles/button.less';
import '@styles/antdRefine.less';


function App() {
  return (
    <ConfigProvider locale={zhTW}>
      <DndProvider backend={HTML5Backend}>
        <LayoutPage />
        </DndProvider>
    </ConfigProvider>
  );
}

export default App;
